import React from 'react';

import { Box, Stack } from '@mui/material';

import SearchBar from 'features/common/SearchBar/SearchBar';
import { classNames } from 'features/common/utils';

import styles from './FilterSearchBar.module.css';

interface FilterSearchBarProps {
  searchTerm: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  expanded?: boolean;
  iconPos?: 'right' | 'left';
  iconCol?: string;
  hasFrame?: boolean;
}

export function FilterSearchBar({
  searchTerm,
  onChange,
  placeholder = 'Search',
  expanded = true,
  iconPos = 'left',
  iconCol = '#8a8a8a',
  hasFrame = true,
}: FilterSearchBarProps) {
  return (
    <Stack
      className={classNames(styles.searchWrapper, hasFrame && styles.frame)}
    >
      <Box className={styles.searchBox}>
        <SearchBar
          expanded={expanded}
          placeholder={placeholder}
          searchTerm={searchTerm}
          onChange={onChange}
          iconPos={iconPos}
          iconCol={iconCol}
          stable
        />
      </Box>
    </Stack>
  );
}
